module.exports = __webpack_public_path__ + "static/img/icon3@2x.09ba309.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/icon3@2x.png
// module id = 7ln3
// module chunks = 69